import AgoraRTC from 'agora-rtc-sdk-ng';
import {mapActions, mapState} from "vuex";

export default {
  name: "telephoneBase",
  data() {
    return {
      appId: 'a17dfbc39a7f4610948e5d4116489cb6',
      isShowCall: false,
      isShowLinking: false,
      isShowTalking: false,
      currentStatus: '',
      mics: [],
      cams: [],
      currentMic: null,
      currentCam: null,
      client: null,
      uid: null,
      remoteUsers: [],
      audioTrack: null,
      videoTrack: null,
      isOpenCam: false,
      myVideoContainer: '',
      videoContainer: null,
      joinData: null,
      deviceStatus: 0,
      mixinsShowText:'',
      telInterval:null,
      telTimeout:null
    }
  },
  computed: {
    ...mapState([
      "rtcRole",
      "realname",
      "lesson_id",
      "userID"
    ]),
  },
  mounted() {
    this.initEvent();
  },
  beforeDestroy() {
    clearTimeout(this.telInterval);
    clearTimeout(this.telTimeout);
    this.$root.eventHub.$off("networkOnline");
    this.$root.eventHub.$off("telOver");
    this.$root.eventHub.$off("telCall");
    this.leave();
  },
  methods: {
    ...mapActions(['uplodeTelephoneError']),
    showTelToast(type) {
      switch (type) {
        case 1:
          this.showText = "连接成功，开始发言吧~";
          break;
        case 2:
          this.showText = `${this.realname}同学，需要积极发言哦~`;
          break;
        case 3:
          this.showText = "麦克风还不能用，快去调试调试";
          break;
        case 4:
          this.showText = "当前网络环境无法发言，下次还有机会发哦~";
          break;
        case 5:
          this.showText = "老师已挂断！";
          break;
        default :
          this.showText = "连接失败";
      }
      this.showToast = 1;
      if(type!==1){
        this.currentStatus = "";
      }
      this.toastTime = 2000;
    },
    initEvent() {
      this.$root.eventHub.$on("telCall", data => {
        // if (this.deviceStatus !== 1)
        //   return;
        this.switchBtnState = 1;
        this.showExpressionFlag = false;
        this.currentStatus = 'call';
        this.joinData = data;
        clearTimeout(this.telInterval);
        this.telInterval = setTimeout(()=>{
          console.log('接听超时---->',this.currentStatus);
          this.showTelToast(2);
          this.currentStatus = '';
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventTelError",
            data: {
              e:  '超时未接听',
            }
          });
        }, 8 * 1000)
        // console.log(this.joinData, data);
      });
      this.$root.eventHub.$on("telOver", data => {
        // console.log('telOver---->',this.currentStatus);
        // if(this.currentStatus==="call" || this.currentStatus === 'linking'){
        //   this.showTelToast(5);//老师已经挂断
        // }
        this.endCall();
      });
    },
    endCall(){
      clearTimeout(this.telInterval);
      clearTimeout(this.telTimeout);
      console.log('endcall---->',this.currentStatus)
      if(this.currentStatus==="talking"){
        this.currentStatus = 'endcall';
        this.$root.eventHub.$emit("restartVideo");
        // this.audioTrack && this.audioTrack.setVolume(0);
        setTimeout(()=>{
          this.leave();
        },1000)
        setTimeout(()=>{
          this.currentStatus = '';
        },2000)
      }else if(this.currentStatus === "call" || this.currentStatus === 'linking'){
        this.showTelToast(5);//老师已经挂断
      }else if(this.currentStatus!=='endcall'){
        this.currentStatus = '';
      }
    },
    async init() {
      await this.checkDevices();
    },
    onClick() {
      console.log('basesClick');
    },
    /**
     * 检测设备
     */
    async checkDevices(type) {
      try {
        // 获取麦克风列表
        this.mics = await AgoraRTC.getMicrophones();
        if(this.mics.length===0){
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventTelDevice",
            data: {
              mic_type:0,
              e: '无麦克风',
            }
          });
          if(type === 'onAnswer'){
            const data = {
              "lessonId":this.lesson_id,//课程id
              "studentId":this.userID,//学生id
              "channelName":this.joinData? this.joinData.channel_name:'',
              "rtcToken":this.joinData?this.joinData.link_mic_token:'',
              "exceptionStatus": 3000,//异常编号
              "exceptionDesc":"无麦克风",//异常信息
            }
            this.uplodeTelephoneError(data);
          }
          this.deviceStatus = "0";
          return '0';
        }
        this.currentMic = this.mics[0];
        // 获取摄像头列表
        // get cameras
        if (this.isOpenCam) {
          // this.cams = await AgoraRTC.getCameras();
          // this.currentCam = this.cams[0];
        }
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventTelDevice",
          data: {
            mic_type:1,
          }
        });
        this.deviceStatus = "1";
        return '1';
      } catch (e) {
        console.log('获取设备失败', e);
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventTelDevice",
          data: {
            mic_type:0,
            e: e.code ? e.code : '获取失败失败',
          }
        });
        if(type === 'onAnswer'){
          const data = {
            "lessonId":this.lesson_id,//课程id
            "studentId":this.userID,//学生id
            "channelName":this.joinData.channel_name,
            "rtcToken":this.joinData.link_mic_token,
            "exceptionStatus": 3000,//异常编号
            "exceptionDesc":"麦克风无权限",//异常信息
          }
          this.uplodeTelephoneError(data);
        }
        return '0';
      }
    },
    /**
     * 切换麦克风
     * @param label
     */
    async switchMic(label) {
      this.currentMic = this.mics.find((mic) => mic.label === label);
      // await localTracks.videoTrack.setDevice(currentMic.deviceId);
    },

    /**
     * 切换摄像头
     * @param label MediaDeviceInfo.label
     */
    async switchCam(label) {
      this.currentCam = this.cams.find((cam) => cam.label === label);
      // await localTracks.videoTrack.setDevice(currentCam.deviceId);
    },

    /**
     *
     * @param id
     * @param channel
     * @param token
     * @param uid
     * @param role audience" | "host
     */
    async join(id, channel, token, uid, role) {
      // "channel_name":"xxxxxxx",
      //   "link_mic_token":"xxxxxxx",
      //   "student_id":1,
      //   "real_name":"张三",
      //   "small_class_id":1,
      //   "small_class_name":"实验班级",
      //   "message_id":"xxxxxx"
      // console.log('join---------')
      if (this.joinData) {
        channel = this.joinData.channel_name;
        token = this.joinData.link_mic_token;
        uid = this.joinData.student_id;
        role = this.rtcRole === 0 ? "audience" : "host";
      } else {
        this.appId = 'a17dfbc39a7f4610948e5d4116489cb6';
        channel = 'face';
        token = '006a17dfbc39a7f4610948e5d4116489cb6IAAV6b1fA6IRy69/aj6eYH7Gel+eozs8Ht4THXUkiFwcsGd7FAUAAAAAEAB2N7Fh9cftXgEAAQD1x+1e';
        uid = '123';
        role = "host";
      }
      this.telTimeout = setTimeout(()=>{
        this.showTelToast();
        this.leave();
      },8 * 1000)
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventTelAnswer",
        data: {
          c: '接电话',
        }
      });
      this.currentStatus = 'linking';
      this.client = AgoraRTC.createClient({mode: 'rtc', codec: 'h264', role});

      // add event listener to play remote tracks when remote user publishs.
      this.client.on('user-published', this.onUserPublished);
      this.client.on('user-unpublished', this.onUserUnpublished);
      this.uid = await this.client.join(this.appId, channel, token, uid).then(
        async () => {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventTelJoin",
            data: {
              c: '电话连接成功',
            }
          });

          if (!this.audioTrack) {
            this.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
          }

          if (!this.videoTrack && this.isOpenCam) {
            this.videoTrack = await AgoraRTC.createCameraVideoTrack();
          }

          // play local video track
          if (this.isOpenCam && this.myVideoContainer) {
            this.videoTrack.play(this.myVideoContainer);
          }
          // publish local tracks to channel
          if (this.videoTrack) {
            await this.client.publish([this.audioTrack, this.videoTrack]);
          } else {
            await this.client.publish([this.audioTrack]);
          }
          console.log('publish success---->',this.currentStatus,this.audioTrack);
          if(this.currentStatus==='linking'){
            this.currentStatus = 'talking';
            this.showTelToast(1);
          }else{
            this.leave();
          }
        }
      ).catch((e) => {
        // console.log(e)
        this.showTelToast();
        const data = {
          "lessonId":this.lesson_id,//课程id
          "studentId":this.userID,//学生id
          "channelName":this.joinData.channel_name,
          "rtcToken":this.joinData.link_mic_token,
          "exceptionStatus":2,//异常编号
          "exceptionDesc": e.code,//异常信息
        }
        this.uplodeTelephoneError(data);
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventAgoraRtcErrorCode",
          data: {
            error_code: e.code ? e.code : '电话连接失败',
          }
        });
        // this.leave(false);
      });
    },

    /**
     * 离开房间
     */
    async leave(manual = true) {
      // console.log('离开');
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventTelLeave",
        data: {
          c: manual ? '退出' : '页面退出'
        }
      });
      if (this.videoTrack) {
        this.videoTrack.stop();
        this.videoTrack.close();
        this.videoTrack = null;
      }
      if (this.audioTrack) {
        this.audioTrack.stop();
        this.audioTrack.close();
        this.audioTrack = null;
      }
      // leave the channel
      if (this.client) {
        await this.client.leave();
      }
    },

    onUserPublished(user, mediaType) {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventTelOtherJoin",
        data: {
          c: '他人加入通话',
          u: user.uid,
        }
      });

      const id = user.uid;
      this.remoteUsers[id] = user;
      this.subscribe(user, mediaType);
    },

    onUserUnpublished(user, mediaType) {
      // todo 远程用户退出，怎么移除播放的音视频？
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventTelOtherLeave",
        data: {
          c: '他人离开通话',
          u: user.uid,
        }
      });
      this.endCall();
      const id = user.uid;
      delete this.remoteUsers[id];
    },

    /**
     * 订阅
     * @param user
     * @param mediaType
     * @return {Promise<void>}
     */
    async subscribe(user, mediaType) {
      // const uid = user.uid;
      // subscribe to a remote user
      // console.log('远程用户id', user.uid);
      await this.client.subscribe(user,mediaType);
      // console.log('subscribe success');
      if (mediaType !== 'audio') {
        // user.videoTrack.play(this.videoContainer[user.uid]);
        user.videoTrack.play('playvideo');
        user.videoTrack.on('first-frame-decoded', ()=>{
          // console.log("解码第一帧")
          clearTimeout(this.telTimeout);
          this.$root.eventHub.$emit("destroyVideo");
          this.loadingShow = false;
          this.loadingErrShow  = false;
        });
      }
      if (mediaType !== 'video') {
        user.audioTrack.play();
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/bussiness/video/mix/telephoneBase.js